exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".warning-summary{border:4px solid #f47738;margin-top:15px;margin-bottom:15px;padding:15px 10px}@media(min-width: 641px){.warning-summary{border:5px solid #f47738;margin-top:30px;margin-bottom:30px;padding:20px 15px 15px}}.warning-summary:focus{outline:3px solid #ffbf47}.warning-summary .warning-summary-heading{margin-top:0}.warning-summary p{margin-bottom:10px}.warning-summary .warning-summary-list{padding-left:0}@media(min-width: 641px){.warning-summary .warning-summary-list li{margin-bottom:5px}}.warning-summary .warning-summary-list a{color:#f47738;font-weight:bold;text-decoration:underline}", ""]);

// exports
